const registry = new Map();
const listeners = new Set();
function notify() {
    listeners.forEach(l => l());
}
/**
 * Register a tab injection at runtime — this is what makes an injected tab render.
 *
 * Receives the FULLY MERGED tab, exactly like `window.registerComponent`: the app's per-project
 * uxp.ts wrapper takes a partial id in code, merges the matching bundle.json `objectTabs` entry
 * (objectType, name, icon, componentId, roles, priority, showUnauthorizedError), generates the
 * composite `bundleId/tabId` id, and calls `window.registerTabInjection` with the result.
 * Do not call this with partial data.
 */
export function registerTabInjection(injection) {
    var _a;
    const normalised = Object.assign(Object.assign({}, injection), { id: injection.id.toLowerCase(), objectType: (_a = injection.objectType) === null || _a === void 0 ? void 0 : _a.toLowerCase() });
    registry.set(normalised.id, normalised);
    notify();
}
export function getAllInjections() {
    return Array.from(registry.values());
}
export function getInjectionsForObjectType(objectType) {
    const key = objectType.toLowerCase();
    return Array.from(registry.values()).filter(c => c.objectType === key);
}
export function unregisterTabInjection(id) {
    const key = id.toLowerCase();
    if (registry.has(key)) {
        registry.delete(key);
        notify();
    }
}
export function onInjectionRegistryChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
